import styles from './PersonalizeQRCode.module.css'
import {
  useState,
  useEffect,
  useMemo,
  useContext,
  useCallback,
  useRef,
} from 'react'
import React from 'react'

import { Slider, ConfigProvider } from 'antd'

import ModelQRCodePage_1 from '../ModelsQRCodePage/components/ModelQRCodePage_1/ModelQRCodePage_1'
import ModelQRCodePage_2 from '../ModelsQRCodePage/components/ModelQRCodePage_2/ModelQRCodePage_2'
import ModelQRCodePage_3 from '../ModelsQRCodePage/components/ModelQRCodePage_3/ModelQRCodePage_3'
import ModelQRCodePage_4 from '../ModelsQRCodePage/components/ModelQRCodePage_4/ModelQRCodePage_4'
import ModelQRCodePage_5 from '../ModelsQRCodePage/components/ModelQRCodePage_5/ModelQRCodePage_5'
import ModelQRCodePage_6 from '../ModelsQRCodePage/components/ModelQRCodePage_6/ModelQRCodePage_6'
import ModelQRCodePage_7 from '../ModelsQRCodePage/components/ModelQRCodePage_7/ModelQRCodePage_7'
import ModelQRCodePage_8 from '../ModelsQRCodePage/components/ModelQRCodePage_8/ModelQRCodePage_8'
import ModelQRCodePage_9 from '../ModelsQRCodePage/components/ModelQRCodePage_9/ModelQRCodePage_9'

import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'
import config from '../../config'

import ReactSelect from 'react-select'

import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'

import { BuilderContext } from '../../pages/Sandbox/components/store/store.Builder'

const MODEL_OPTIONS = [
  { label: 'Modèle 1', keyReference: 'model1', component: ModelQRCodePage_1 },
  { label: 'Modèle 2', keyReference: 'model2', component: ModelQRCodePage_2 },
  { label: 'Modèle 3', keyReference: 'model3', component: ModelQRCodePage_3 },
  { label: 'Modèle 4', keyReference: 'model4', component: ModelQRCodePage_4 },
  { label: 'Modèle 5', keyReference: 'model5', component: ModelQRCodePage_5 },
  { label: 'Modèle 6', keyReference: 'model6', component: ModelQRCodePage_6 },
  { label: 'Modèle 7', keyReference: 'model7', component: ModelQRCodePage_7 },
  { label: 'Modèle 8', keyReference: 'model8', component: ModelQRCodePage_8 },
  { label: 'Modèle 9', keyReference: 'model9', component: ModelQRCodePage_9 },
]

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    background: 'var(--white)',
    borderColor: 'var(--washed-gray)',
    minHeight: '28px',
    height: '28px',
    boxShadow: state.isFocused ? null : null,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '28px',
    padding: '0 6px',
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = 'opacity 300ms'

    return {
      ...provided,
      opacity,
      transition,
      color: 'var(--dark-gray)',
      fontFamily: 'var(--sans-serif)', // Changer la police du texte du singleValue
      fontSize: 'var(--size-font-input)', // Changer la taille du texte du singleValue
    }
  },
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? 'var(--darkened-background)'
      : 'var(--white)', // Changer la couleur d'arrière-plan de l'option
    color: state.isFocused ? 'var(--dark-gray)' : 'var(--dark-gray)', // Changer la couleur du texte de l'option
  }),
  menu: (provided, state) => ({
    ...provided,
    backgroundColor: 'var(--white)', // Changer la couleur de fond du menu déroulant
  }),
  indicatorSeparator: (state) => ({
    display: 'none',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: '28px',
  }),
}

const CANVAS_WIDTH = config.PAGE_QRCODE_WIDTH
const CANVAS_HEIGHT = config.PAGE_QRCODE_HEIGHT

const DEFAULT_DATA = {
  model: 'model1',
  logo: '0',
  primaryMessage: 'SCANNEZ MOI',
  secondaryMessage: 'Donnez nous votre avis !',
}

const LogoSelect = ({ currentLogo, onLogoChange }) => {
  const LOGO_OPTIONS = [
    { label: 'Aucun', keyReference: '0' },
    { label: 'Métropole', keyReference: '1' },
    { label: 'Ville', keyReference: '2' },
    { label: 'Métropole & Ville', keyReference: '3' },
  ]

  const options = LOGO_OPTIONS.map((logo) => ({
    value: logo.keyReference,
    label: logo.label,
  }))

  const handleChange = (selectedOption) => {
    onLogoChange(selectedOption ? selectedOption.value : '')
  }

  const selectedOption = options.find((option) => option.value === currentLogo)

  return (
    <ReactSelect
      value={selectedOption}
      onChange={handleChange}
      options={options}
      styles={customStyles}
    />
  )
}

const PersonalizeQRCode = observer(({ url }) => {
  const builderContext = useContext(BuilderContext)

  const pdfRef = useRef()

  const ensureRequiredProperties = useCallback((data) => {
    return { ...DEFAULT_DATA, ...data }
  }, [])

  const myData = builderContext.styleForm.qr_code_design || DEFAULT_DATA

  const [zoom, setZoom] = useState(30)
  const scale = useMemo(() => zoom / 100, [zoom])

  const handleInputChange = useCallback(
    (key, value) => {
      builderContext.setStyleFormQRCode_designWithoutSave(
        ensureRequiredProperties({
          ...builderContext.styleForm.qr_code_design,
          [key]: value,
        })
      )
    },
    [builderContext, ensureRequiredProperties]
  )

  const downloadPDF = async () => {
    const scaleValue = 6 // Ajustez cette valeur pour la qualité
    const canvasElement = pdfRef.current

    const canvas = await html2canvas(canvasElement, {
      scale: scaleValue,
      useCORS: true,
    })

    // Créez un PDF de format A4
    const pdf = new jsPDF('p', 'mm', [210, 297])

    const imgWidth = 210 // largeur du format A4 en mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width // Calculer la hauteur basée sur le ratio du canvas

    // Ajoutez l'image au PDF
    pdf.addImage(
      canvas.toDataURL('image/png', 1), // Utilisez une qualité maximale pour la conversion
      'PNG',
      0,
      0,
      imgWidth,
      imgHeight
    )

    // Enregistrez le PDF
    pdf.save('QRCode.pdf')
  }

  const handleBlur = useCallback(
    (key, value) => {
      builderContext.setStyleFormQRCode_design(
        ensureRequiredProperties({
          ...builderContext.styleForm.qr_code_design,
          [key]: value,
        })
      )
    },
    [builderContext, ensureRequiredProperties]
  )

  const foundModel = MODEL_OPTIONS.find(
    (modelOption) => modelOption.keyReference === myData.model
  )

  return (
    <div className={styles.container}>
      <aside className={styles.sidebarLeft}>
        <div className={styles.header__sidebar}>
          <div className={styles.header__sidebar__title}>
            Personnalisation de la page
          </div>
        </div>

        <div className={styles.sidebar__container}>
          <div className={styles.sidebar__allparams__content}>
            <div className={styles.sidebar__section__content}>
              <div className={styles.sidebar__title__category}>
                Message primaire
              </div>
              <div>
                <textarea
                  type="text"
                  className={styles.TextAreaInput__container}
                  placeholder="Message du titre"
                  value={myData.primaryMessage}
                  onChange={(e) =>
                    handleInputChange('primaryMessage', e.target.value)
                  }
                  onBlur={(e) => handleBlur('primaryMessage', e.target.value)}
                />
              </div>
            </div>

            <div className={styles.sidebar__section__content}>
              <div className={styles.sidebar__title__category}>
                Message secondaire
              </div>
              <div>
                <textarea
                  className={styles.TextAreaInput__container}
                  type="text"
                  placeholder="Titre de l'organisation"
                  value={myData.secondaryMessage}
                  onChange={(e) =>
                    handleInputChange('secondaryMessage', e.target.value)
                  }
                  onBlur={(e) => handleBlur('secondaryMessage', e.target.value)}
                />
              </div>
            </div>

            <div className={styles.sidebar__section__content}>
              <div className={styles.sidebar__title__category}>
                Choisissez un logo
              </div>
              <LogoSelect
                currentLogo={myData.logo}
                onLogoChange={(logoKeyReference) =>
                  builderContext.setStyleFormQRCode_design(
                    ensureRequiredProperties({
                      ...builderContext.styleForm.qr_code_design,
                      logo: logoKeyReference,
                    })
                  )
                }
              />
            </div>

            <div className={styles.sidebar__section__content}>
              <div className={styles.sidebar__title__category}>
                Choisissez un modèle
              </div>
              <div className={styles.modelsGrid}>
                {MODEL_OPTIONS.map((modelOption, index) => (
                  <div
                    className={
                      myData.model === modelOption.keyReference
                        ? `${styles.preview__container} ${styles.selectedModel}`
                        : styles.preview__container
                    }
                    key={index}
                  >
                    <div
                      onClick={() =>
                        builderContext.setStyleFormQRCode_design(
                          ensureRequiredProperties({
                            ...builderContext.styleForm.qr_code_design,
                            model: modelOption.keyReference,
                          })
                        )
                      }
                    >
                      <div className={styles.modelContainer}>
                        {React.createElement(modelOption.component, {
                          qrCodeUrl: url,
                          primaryMessage: myData.primaryMessage,
                          secondaryMessage: myData.secondaryMessage,
                          logo: myData.logo,
                        })}
                      </div>
                      <div className={styles.disableInteraction}></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </aside>

      <div className={styles.main}>
        <div className={styles.innerHeader}>
          <div className={styles.download_button} onClick={downloadPDF}>
            Télécharger en PDF
          </div>
        </div>

        <div className={styles.body}>
          <div className={styles.containerBody}>
            <div className={styles.contentBody}>
              <div className={styles.bodyContain}>
                <div className={styles.bodyItem}></div>
                <div className={styles.bodyCanvas}>
                  <div
                    className={styles.container__canvas}
                    ref={pdfRef}
                    style={{
                      width: `${CANVAS_WIDTH * scale}px`,
                      height: `${CANVAS_HEIGHT * scale}px`,
                    }}
                  >
                    <div
                      className={styles.zoom}
                      style={{
                        transform: `scale(${scale})`,
                      }}
                    >
                      {foundModel &&
                        React.createElement(foundModel.component, {
                          qrCodeUrl: url,
                          primaryMessage: myData.primaryMessage,
                          secondaryMessage: myData.secondaryMessage,
                          logo: myData.logo,
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.innerFooter}>
          <ConfigProvider
            theme={{
              token: {},
              components: {
                Slider: {
                  trackBg: '#000000',
                  dotActiveBorderColor: '#000000',
                  handleActiveColor: '#000000',
                  handleColor: '#000000',
                  trackHoverBg: '#000000',
                  fontFamily: 'var(--sans-serif)',
                  colorBorderSecondary: 'rgba(224, 224, 224)',
                  colorFillAlter: 'rgba(0, 0, 0, 0.05)',
                },
              },
            }}
          >
            <Slider
              className={styles.slider}
              min={10}
              max={200}
              value={zoom}
              onChange={(value) => setZoom(value)}
            />
          </ConfigProvider>
        </div>
      </div>
    </div>
  )
})

export default PersonalizeQRCode
